"use client"

import { useEffect } from "react"
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import styled, { createGlobalStyle } from "styled-components"
import AOS from "aos"
import "aos/dist/aos.css"
import { Toaster } from "react-hot-toast"

// Components
import Navbar from "./components/Navbar"
import LoadingScreen from "./components/LoadingScreen"
import ScrollToTop from "./components/ScrollToTop"
import CustomCursor from "./components/CustomCursor"
import ScrollProgress from "./components/ScrollProgress"
import ParticleBackground from "./components/ParticleBackground"
import MobileOptimized from "./components/MobileOptimized"

// Pages
import Home from "./pages/Home"
import About from "./pages/About"
import Projects from "./components/Projects"
import Certificates from "./pages/Certificates"
import Contact from "./components/sections/Contact"

// Context
import { useApp } from "./contexts/AppContext"

// --- Create Global Styles ---
// This component injects styles into the document's <head>, targeting the <body>
// to set a global background for the entire application.
const GlobalStyle = createGlobalStyle`
  body {
    /* Vertical gradient from the theme's dark blue-green to the light beige */
    background: linear-gradient(180deg, #264653 0%, #F4F1DE 35%);
    
    /* This ensures the gradient doesn't scroll with the page content, creating a fixed backdrop */
    background-attachment: fixed;
    
    /* Set a default text color from your palette */
    color: #1B1B1E;
    
    /* Reset default margin and set a base font */
    margin: 0;
    font-family: 'Poppins', sans-serif; /* Example font, adjust if needed */
  }

  /* Ensure component backgrounds are transparent by default where needed */
  .App {
    background-color: transparent;
  }
`

function App() {
  const { isLoading } = useApp()

  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: "ease-in-out",
      once: true,
      mirror: false,
      disable: window.innerWidth < 768,
    })
  }, [])

  if (isLoading) {
    return <LoadingScreen />
  }

  return (
    <Router>
      {/* Render GlobalStyle here to apply it everywhere */}
      <GlobalStyle />

      <MobileOptimized>
        <div className="App">
          <CustomCursor />
          <ScrollProgress />
          <ParticleBackground />
          <Navbar />

          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/certificates" element={<Certificates />} />
              <Route path="/contact" element={<Contact />} />
            </Routes>
          </main>

          <ScrollToTop />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                // Updated styles to match the new color palette
                background: "#F4F1DE", // Light Beige
                color: "#1B1B1E", // Almost Black text
                border: "1px solid #2A9D8F", // Teal border
                borderRadius: "12px",
                boxShadow: "0 4px 15px rgba(42, 157, 143, 0.2)", // Soft teal shadow
              },
            }}
          />
        </div>
      </MobileOptimized>
    </Router>
  )
}

export default App